import { RaptorPoint } from './constant';
import { env } from './env';
/**
 * Name: CAT异常监控
 */
class Monitor {
  private config: any = {};
  private extInfo: any = {};
  private isDev: boolean = true;

  constructor(isDev: boolean) {
    if (!Owl) {
      return;
    }
    this.isDev = isDev;
    this.init();
    Owl.start(this.config);
  }
  init() {
    this.config = {
      project: 'pay-settings',
      pageUrl: `${location.origin}${location.pathname}`,
      devMode: this.isDev,
      resource: {
        sampleApi: 1,
        delay: 0
      },
      page: {
        auto: true,
        sample: 1,
        delay: 0,
        sensoryIndex: false
      },
      error: {
        sample: 1,
        combo: false
      },
      ajax: {
        flag: true,
        duration: 8000
      },
      metric: {
        sample: 1,
        combo: true
      },
      // logan 1.12.5 是Owl 1.8.12引入的，这里logan会引入KNB 1.6.5，和KNB Next有冲突，开启时需注意低版本KNB在覆盖了KNB Next之后，openPage 等高级方法直接失效。
      logan: {
        enable: true
      },
      onErrorPush: (error: any) => error.updateTags({
        ...this.defaultInfo,
      }),
    };
  }

  get defaultInfo() {
    return {
      ...env.commonParams,
      entry: env.entry,
    };
  }

  captureMessage(error: string | SubErrorType, config = {} as ICatErrorModel) {
    const baseConfig: ICatErrorModel = {
      level: 'info',
      category: 'custom_info'
    };

    // 上报 自定义类别 错误异常
    Owl.addError(error, {
      ...baseConfig,
      ...config
    });
  }
  reportMetric(key: string, tags = {}, value?: any): void {
    const metricManager = Owl.metricManager;
    metricManager.setTags({
      ...tags
    });
    metricManager.setMetric(key, value || 1);
    // 强制上报所有
    metricManager.report();
  }
  // 上报TTI
  reportPoint(position: number, duration = null): void {
    const param: CustomPoint = { position };
    if (duration) {
      param.duration = duration || 0;
    }
    Owl.addPoint(param);
    Owl.sendPoints();
    console.log('已上报TTI');
  }
  /**
   * 上报 TTI
   */
  reportTTI(): void {
    try {
      if ((window as any).alreadySentTTI) {
        return;
      }
      this.reportPoint(RaptorPoint.TTIPosition);
      (window as any).alreadySentTTI = true;
    } catch (error) {
      this.captureMessage('上报 TTI 异常');
    }
  }
}


const isProduct = /npay\.meituan\.com/.test(location.host);
export const monitor = new Monitor(!isProduct);

